import { State } from 'redux/rootReducer'

export const getVideoStreamingItemSelector = (fileId: string) => (state: State) =>
  state.videoStreaming.list[fileId] ?? {}
